module.exports = __webpack_public_path__ + "static/media/thong-bao-nang-cap.bb2d71d0.jpg";